module.exports = __webpack_public_path__ + "static/media/canstar-2021.a5472cc7.png";